/**
 * Setting_Service.ts
 * Read + upsert + lifecycle for per-location settings (adapter /v1/settings).
 */

import { apiClient } from '../../api/axiosInstance';
import { Hosp_Settings_Url, Hosp_Setting_Url } from '../../api/endpoints';
import type { Setting, UpsertSettingInput } from '../../schemas/config/setting';

export const getSettings = async (locationId?: string): Promise<Setting[]> => {
  const { data } = await apiClient.get<Setting[]>(Hosp_Settings_Url, {
    params: locationId ? { locationId } : undefined,
  });
  return data;
};

export const upsertSetting = async (input: UpsertSettingInput): Promise<Setting> => {
  const { data } = await apiClient.put<Setting>(Hosp_Settings_Url, input);
  return data;
};

export const deactivateSetting = async (id: string): Promise<void> => {
  await apiClient.delete(Hosp_Setting_Url(id));
};
